var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"about-page-wrap container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 white-box about-information"},[_c('div',{attrs:{"id":"about-html"},domProps:{"innerHTML":_vm._s(_vm.aboutHtml)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }